/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabEquipment from './diaglab-equipment';
import DiaglabEquipmentDetail from './diaglab-equipment-detail';
import DiaglabEquipmentUpdate from './diaglab-equipment-update';
import DiaglabEquipmentDeleteDialog from './diaglab-equipment-delete-dialog';

const DiaglabEquipmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabEquipment />} />
    <Route path="new" element={<DiaglabEquipmentUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabEquipmentDetail />} />
      <Route path="edit" element={<DiaglabEquipmentUpdate />} />
      <Route path="delete" element={<DiaglabEquipmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabEquipmentRoutes;
